var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatRightDotsFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat-right-dots-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.116,
    viewBox: "0 0 20 19.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M20,2.5A2.5,2.5,0,0,0,17.5,0H2.5A2.5,2.5,0,0,0,0,2.5v10A2.5,2.5,0,0,0,2.5,15H14.483a1.25,1.25,0,0,1,.884.366l3.566,3.566A.625.625,0,0,0,20,18.491ZM6.25,7.5A1.25,1.25,0,1,1,5,6.25,1.25,1.25,0,0,1,6.25,7.5Zm5,0A1.25,1.25,0,1,1,10,6.25,1.25,1.25,0,0,1,11.25,7.5ZM15,8.75A1.25,1.25,0,1,1,16.25,7.5,1.25,1.25,0,0,1,15,8.75Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRightDotsFill);
export default __webpack_public_path__ + "static/media/chat-right-dots-fill.3e41d5e88d50d273de4793126330165d.svg";
export { ForwardRef as ReactComponent };